import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiServiceService } from '../../../services/api-service.service';

@Injectable({
    providedIn: 'root'
})
export class PersonalInterviewsService {
    refreshList = new BehaviorSubject<boolean>(false);

    constructor(private _apiService: ApiServiceService) { }

    getPersonalInterviews(model: any) {
        return this._apiService.get(`${environment.apiUrl}/recruitment/applicant-interviews`, model).pipe(catchError(this.handleError));
    }

    getinterviewerForJob(post_job_id: any) {
        return this._apiService.get(`${environment.apiUrl}/recruitment/job-post-interviewer-responsible?post_job_id=${post_job_id}`).pipe(catchError(this.handleError));
    }

    getEvaluationCriterias(post_job_id: any) {
        return this._apiService.get(`${environment.apiUrl}/recruitment/lookup-data-evaluation-criterias?post_job_id=${post_job_id}`).pipe(catchError(this.handleError));
    }

    evaluateInterview(model: any) {
        return this._apiService.post(`${environment.apiUrl}/recruitment/evaluation-interview`, model).pipe(catchError(this.handleError));
    }

    getInterviewEvaluationDetails(model?: any) {
        return this._apiService.get(`${environment.apiUrl}/recruitment/evaluation-interview`, model).pipe(catchError(this.handleError));
    }

    handleError(error: any) {
        return throwError(error);
    }
}